import { UxFlavor } from "slices/explorer/types";

/** Subset of Navigator used to decide whether the device is a handheld. */
export type GpuBudgetNavigator = {
    userAgent: string;
    userAgentData?: { mobile?: boolean };
};

/**
 * True for actual handhelds. Does **not** use detect-gpu's `isMobile`, which
 * treats `MacIntel` + `maxTouchPoints > 0` as an iPad and flags desktop Macs.
 *
 * WebKit has no `userAgentData`, and iPadOS typically reports a desktop
 * "Macintosh" UA, so Procore iOS/Android UX flavors are treated as mobile
 * regardless of the UA.
 */
export function isMobileGpuBudgetDevice(nav: GpuBudgetNavigator = navigator, uxFlavor?: UxFlavor): boolean {
    if (uxFlavor === UxFlavor.ProcoreIOS || uxFlavor === UxFlavor.ProcoreAndroid) {
        return true;
    }
    if (typeof nav.userAgentData?.mobile === "boolean") {
        return nav.userAgentData.mobile;
    }
    return /android/i.test(nav.userAgent) || /(iphone|ipod|ipad)/i.test(nav.userAgent);
}
